import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479416b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asFreezeCalendar" }
const _hoisted_2 = { class: "asFreezeCalendar_handlerWrapper" }
const _hoisted_3 = { class: "asFreezeCalendar_label" }
const _hoisted_4 = { class: "asFreezeCalendar_date" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "asFreezeCalendar_icon" }, null, -1))
const _hoisted_6 = { class: "asFreezeCalendar_label" }
const _hoisted_7 = { class: "asFreezeCalendar_date" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "asFreezeCalendar_icon" }, null, -1))
const _hoisted_9 = { class: "asFreezeCalendar_modal" }
const _hoisted_10 = { class: "asFreezeCalendar_modal_actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_maz_picker = _resolveComponent("maz-picker")!
  const _component_as_button = _resolveComponent("as-button")!
  const _component_as_modal = _resolveComponent("as-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["asFreezeCalendar_handler", {
          '-disabled': _ctx.disabled
        }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowModal('start')))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.labels.start), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.formattedDate.start), 1),
          _hoisted_5
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["asFreezeCalendar_handler", {
          '-disabled': _ctx.disabled
        }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onShowModal('end')))
      }, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.labels.end), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(_ctx.formattedDate.end), 1),
          _hoisted_8
        ])
      ], 2)
    ]),
    _createVNode(_component_as_modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
      "btn-close": false,
      "type-modal": "picker"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_maz_picker, {
            "model-value": _ctx.currentValue,
            "onUpdate:modelValue": _ctx.onSelect,
            format: "YYYY-MM-DD",
            color: "primary",
            "auto-close": "",
            "no-header": "",
            "input-date-style": _ctx.inputDateStyle,
            inline: "",
            "min-date": _ctx.minDate,
            "max-date": _ctx.maxDateRange,
            "no-shortcuts": ""
          }, null, 8, ["model-value", "onUpdate:modelValue", "input-date-style", "min-date", "max-date"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_as_button, {
              class: _normalizeClass(["asFreezeCalendar_btn", {
              '-disabled': _ctx.isDisabledClose
            }]),
              onClick: _ctx.onCloseModal,
              disabled: _ctx.isDisabledClose
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('select')), 1)
              ]),
              _: 1
            }, 8, ["class", "onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}